/// <reference path="SearchBox.js" />

class GamesSearchBox extends SearchBox {
	constructor(el, options) {
		super(el, options);
		this.listSelector = ".mia-SearchGameList";
		this.categoriesSelector = ".mia-AllGames";
	}

	onSearchButtonClick(event) {
		super.onSearchButtonClick(event);
		var searchText = this.inputBox.value;

		if (searchText) {
			jQuery(this.listSelector).show();
			jQuery(this.categoriesSelector).hide();
		} else {
			jQuery(this.categoriesSelector).show();
			jQuery(this.listSelector).hide();
		}
	}
}
